import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Search = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="search"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8522 15.7232H16.7258L16.3276 15.3375C17.7246 13.7076 18.5647 11.5925 18.5647 9.29123C18.5647 4.15963 14.4171 0 9.30186 0C4.18352 0 0.0390625 4.15963 0.0390625 9.29123C0.0390625 14.4223 4.18352 18.5819 9.30186 18.5819C11.595 18.5819 13.7046 17.7389 15.3288 16.3379L15.7146 16.738V17.8672L22.8398 25L24.9618 22.8704L17.8522 15.7232ZM9.30186 15.7232C5.7517 15.7232 2.88917 12.8501 2.88917 9.29123C2.88917 5.7318 5.7517 2.85869 9.30186 2.85869C12.8489 2.85869 15.7146 5.7318 15.7146 9.29123C15.7146 12.8501 12.8489 15.7232 9.30186 15.7232Z"
      />
    </svg>
  );
};
/* eslint-enable max-len */

Search.defaultProps = {
  className: null,
};

Search.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Search;
